import { TARGET } from "../constants/target.qwik.mjs";
import { convertStyleMapToCSSArray } from "../helpers/css.qwik.mjs";
import { transformStyleProperty } from "./transform-style-property.qwik.mjs";
const getStyle = ({ block, context }) => {
  return mapStyleObjToStrIfNeeded(transformStyleProperty({
    style: block.style || {},
    context,
    block
  }));
};
function mapStyleObjToStrIfNeeded(style) {
  switch (TARGET) {
    case "svelte":
    case "vue":
    case "solid":
    case "angular":
      return convertStyleMapToCSSArray(style).join(" ");
    case "qwik":
    case "reactNative":
    case "react":
    case "rsc":
      return style;
  }
}
export {
  getStyle,
  mapStyleObjToStrIfNeeded
};
